import { ApiDOMStructuredError } from '@swagger-api/apidom-error';
class JsonPointerError extends ApiDOMStructuredError {}
export default JsonPointerError;